const AppActionTypes = {
    getSettings: "getSettings",
    getValidationRules: "getValidationRules",
    getUser: "getUser"
};

export default AppActionTypes;
